import {Card, CardContent, Typography, Grid} from "@material-ui/core";

export default function CommentCompactView({comment}) {
    return (
        <>
            <Card variant={"elevation"} style={{marginBottom: 5}}>
                <CardContent sx={{display: 'flex', flexDirection: 'row'}}>
                    <Grid container>
                        <Grid item xs={12} md={12}>
                            <Typography color="textSecondary" variant="subtitle1" style={{fontSize: 11}}>
                                { new Date(comment.createdAt)?.toLocaleString()} by {comment.createdBy}
                            </Typography>
                            <br/>
                            <Typography color="textPrimary">
                                {comment.comment ? `${comment.comment}` : "n/a"}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}
